import {
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
    Typography,
} from "@material-ui/core";
import React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
function ReoEmailTemplate({
    value,
    control,
    item,
    index,
    handleRadioChange,
    register,
    lockStringTitle,
    inputWithLockString,
    unchangedTitleNum,
    unchangedPart,
    TabPanel,
    errors,
    indexEmailContent,
}) {
    const { t, i18n } = useTranslation();
    return (
        <React.Fragment>
            {/* Tab for SSDO */}
            {"titleSsdo" in indexEmailContent && (
                <TabPanel value={value} index={7}>
                    <React.Fragment key={i18n.language}>
                        <Controller
                            control={control}
                            name={`emailContent.${index}.enableSsdo`}
                            render={({ field }) => (
                                <RadioGroup
                                    aria-label={`emailContent.${index}.enableSsdo`}
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleRadioChange(
                                            e,
                                            `emailContent.${index}.enableSsdo`
                                        );
                                    }}
                                    row
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label={t("common.portal.enable")}
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label={t("common.portal.disable")}
                                    />
                                </RadioGroup>
                            )}
                        />
                        <Typography variant="h6">
                            {t("common.portal.emailTitle")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            defaultValue={`${item}.titleSsdo`}
                            inputProps={register(
                                `emailContent.${index}.titleSsdo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 7
                                                ? v.includes(unchangedTitleNum)
                                                : true ||
                                                  "Ref Num needs to be kept of ReoEmailTemplate ssdo",
                                    },
                                }
                            )}
                            onKeyUp={(e) => lockStringTitle(e, "ssdo", index)}
                        ></CustomTextField>
                        <Typography
                            variant="h6"
                            style={{
                                marginTop: "1rem",
                            }}
                        >
                            {t("common.portal.emailContent")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            multiline
                            rows={5}
                            defaultValue={`${item}.finalEmailSsdoInfo`}
                            inputProps={register(
                                `emailContent.${index}.finalEmailSsdoInfo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) => {
                                            return value == 7
                                                ? v.includes(unchangedPart)
                                                : true ||
                                                      "Url link and Ref Num needs to be kept of ReoEmailTemplate ssdo";
                                        },
                                    },
                                }
                            )}
                            onKeyUp={(e) =>
                                inputWithLockString(e, "ssdo", index)
                            }
                        ></CustomTextField>
                        <FormHelperText>
                            <ErrorMsg message={errors} />
                        </FormHelperText>
                    </React.Fragment>
                </TabPanel>
            )}
            {/* Tab for SDO */}
            {"titleSdo" in indexEmailContent && (
                <TabPanel value={value} index={8}>
                    <React.Fragment key={i18n.language}>
                        <Controller
                            control={control}
                            name={`emailContent.${index}.enableSdo`}
                            render={({ field }) => (
                                <RadioGroup
                                    aria-label={`emailContent.${index}.enableSdo`}
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleRadioChange(
                                            e,
                                            `emailContent.${index}.enableSdo`
                                        );
                                    }}
                                    row
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label={t("common.portal.enable")}
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label={t("common.portal.disable")}
                                    />
                                </RadioGroup>
                            )}
                        />
                        <Typography variant="h6">
                            {t("common.portal.emailTitle")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            defaultValue={`${item}.titleSdo`}
                            inputProps={register(
                                `emailContent.${index}.titleSdo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 8
                                                ? v.includes(unchangedTitleNum)
                                                : true ||
                                                  "Ref Num needs to be kept of ReoEmailTemplate sdo",
                                    },
                                }
                            )}
                            onKeyUp={(e) => lockStringTitle(e, "sdo", index)}
                        ></CustomTextField>
                        <Typography
                            variant="h6"
                            style={{
                                marginTop: "1rem",
                            }}
                        >
                            {t("common.portal.emailContent")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            multiline
                            rows={5}
                            defaultValue={`${item}.finalEmailSdoInfo`}
                            inputProps={register(
                                `emailContent.${index}.finalEmailSdoInfo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 8
                                                ? v.includes(unchangedPart)
                                                : true ||
                                                  "Url link and Ref Num needs to be kept of ReoEmailTemplate sdo",
                                    },
                                }
                            )}
                            onKeyUp={(e) =>
                                inputWithLockString(e, "sdo", index)
                            }
                        ></CustomTextField>
                        <FormHelperText>
                            <ErrorMsg message={errors} />
                        </FormHelperText>
                    </React.Fragment>
                </TabPanel>
            )}
            {/* Tab for CSDO */}
            {"titleCsdo" in indexEmailContent && (
                <TabPanel value={value} index={9}>
                    <React.Fragment key={i18n.language}>
                        <Controller
                            control={control}
                            name={`emailContent.${index}.enableCsdo`}
                            render={({ field }) => (
                                <RadioGroup
                                    aria-label={`emailContent.${index}.enableCsdo`}
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleRadioChange(
                                            e,
                                            `emailContent.${index}.enableCsdo`
                                        );
                                    }}
                                    row
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label={t("common.portal.enable")}
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label={t("common.portal.disable")}
                                    />
                                </RadioGroup>
                            )}
                        />
                        <Typography variant="h6">
                            {t("common.portal.emailTitle")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            defaultValue={`${item}.titleCsdo`}
                            inputProps={register(
                                `emailContent.${index}.titleCsdo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 9
                                                ? v.includes(unchangedTitleNum)
                                                : true ||
                                                  "Ref Num needs to be kept of ReoEmailTemplate csdo",
                                    },
                                }
                            )}
                            onKeyUp={(e) => lockStringTitle(e, "csdo", index)}
                        ></CustomTextField>
                        <Typography
                            variant="h6"
                            style={{
                                marginTop: "1rem",
                            }}
                        >
                            {t("common.portal.emailContent")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            multiline
                            rows={5}
                            defaultValue={`${item}.finalEmailCsdoInfo`}
                            inputProps={register(
                                `emailContent.${index}.finalEmailCsdoInfo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 9
                                                ? v.includes(unchangedPart)
                                                : true ||
                                                  "Url link and Ref Num needs to be kept of ReoEmailTemplate csdo",
                                    },
                                }
                            )}
                            onKeyUp={(e) =>
                                inputWithLockString(e, "csdo", index)
                            }
                        ></CustomTextField>
                        <FormHelperText>
                            <ErrorMsg message={errors} />
                        </FormHelperText>
                    </React.Fragment>
                </TabPanel>
            )}
            {/* Tab for SERVO */}
            {"titleServo" in indexEmailContent && (
                <TabPanel value={value} index={10}>
                    <React.Fragment key={i18n.language}>
                        <Controller
                            control={control}
                            name={`emailContent.${index}.enableServo`}
                            render={({ field }) => (
                                <RadioGroup
                                    aria-label={`emailContent.${index}.enableServo`}
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleRadioChange(
                                            e,
                                            `emailContent.${index}.enableServo`
                                        );
                                    }}
                                    row
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label={t("common.portal.enable")}
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label={t("common.portal.disable")}
                                    />
                                </RadioGroup>
                            )}
                        />
                        <Typography variant="h6">
                            {t("common.portal.emailTitle")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            defaultValue={`${item}.titleServo`}
                            inputProps={register(
                                `emailContent.${index}.titleServo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            v.includes(unchangedTitleNum) ||
                                            "Ref Num needs to be kept",
                                    },
                                }
                            )}
                            onKeyUp={(e) => lockStringTitle(e, "servo", index)}
                        ></CustomTextField>
                        <Typography
                            variant="h6"
                            style={{
                                marginTop: "1rem",
                            }}
                        >
                            {t("common.portal.emailContent")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            multiline
                            rows={5}
                            defaultValue={`${item}.finalEmailServoInfo`}
                            inputProps={register(
                                `emailContent.${index}.finalEmailServoInfo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            v.includes(unchangedPart) ||
                                            "Url link and Ref Num needs to be kept of ReoEmailTemplate 4",
                                    },
                                }
                            )}
                            onKeyUp={(e) =>
                                inputWithLockString(e, "servo", index)
                            }
                        ></CustomTextField>
                        <FormHelperText>
                            <ErrorMsg message={errors} />
                        </FormHelperText>
                    </React.Fragment>
                </TabPanel>
            )}
            {/* Tab for Clerical Staff */}
            {"titleClerStaff" in indexEmailContent && (
                <TabPanel value={value} index={11}>
                    <React.Fragment key={i18n.language}>
                        <Controller
                            control={control}
                            name={`emailContent.${index}.enableClericalStaff`}
                            render={({ field }) => (
                                <RadioGroup
                                    aria-label={`emailContent.${index}.enableClericalStaff`}
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleRadioChange(
                                            e,
                                            `emailContent.${index}.enableClericalStaff`
                                        );
                                    }}
                                    row
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label={t("common.portal.enable")}
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label={t("common.portal.disable")}
                                    />
                                </RadioGroup>
                            )}
                        />
                        <Typography variant="h6">
                            {t("common.portal.emailTitle")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            defaultValue={`${item}.titleClerStaff`}
                            inputProps={register(
                                `emailContent.${index}.titleClerStaff`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 11
                                                ? v.includes(unchangedTitleNum)
                                                : true ||
                                                  "Ref Num needs to be kept of ReoEmailTemplate clericalStaff",
                                    },
                                }
                            )}
                            onKeyUp={(e) =>
                                lockStringTitle(e, "clericalStaff", index)
                            }
                        ></CustomTextField>
                        <Typography
                            variant="h6"
                            style={{
                                marginTop: "1rem",
                            }}
                        >
                            {t("common.portal.emailContent")}
                        </Typography>
                        <CustomTextField
                            fullWidth
                            multiline
                            rows={5}
                            defaultValue={`${item}.finalEmailClerStaffInfo`}
                            inputProps={register(
                                `emailContent.${index}.finalEmailClerStaffInfo`,
                                {
                                    required: t("errorMsg.required"),
                                    validate: {
                                        stringInclude: (v) =>
                                            value == 11
                                                ? v.includes(unchangedPart)
                                                : true ||
                                                  "Url link and Ref Num needs to be kept of ReoEmailTemplate clericalStaff",
                                    },
                                }
                            )}
                            onKeyUp={(e) =>
                                inputWithLockString(e, "clericalStaff", index)
                            }
                        ></CustomTextField>
                        <FormHelperText>
                            <ErrorMsg message={errors} />
                        </FormHelperText>
                    </React.Fragment>
                </TabPanel>
            )}
        </React.Fragment>
    );
}
export default ReoEmailTemplate;
